export class TableEvent extends CustomEvent {
    constructor(opts) {
        super('cell-click');
        this.cell = opts.cell;
        this.x = opts.x;
        this.y = opts.y;
    }
    getCell() {
        return this.cell;
    }
    getX() {
        return this.x ?? 0;
    }
    getY() {
        return this.y ?? 0;
    }
}
